import { Component, OnInit } from '@angular/core';

interface Gallery {
  id?: number;
  image: string;
}

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  gallery: Gallery[] = [
    { id: 1, image: 'assets/img/gallery-01.png' },
    { id: 2, image: 'assets/img/gallery-01.png' },
    { id: 3, image: 'assets/img/gallery-01.png' },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
